'use client'

import { usePathname } from 'next/navigation'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { WorkspaceNavigationProvider } from '@/contexts/WorkspaceNavigationContext'

export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const isPublicCasePage = typeof pathname === 'string' && pathname.startsWith('/case/public/')
  const isPublicPortfolioPage = typeof pathname === 'string' && /^\/portfolio\/[^/]+/.test(pathname)

  if (isPublicCasePage || isPublicPortfolioPage) {
    return <>{children}</>
  }

  return (
    <WorkspaceNavigationProvider>
      <Header />
      <main>{children}</main>
      <Footer />
    </WorkspaceNavigationProvider>
  )
}
